import { rootApi } from '../rootApi';

// VAF / PSI / CVRF tarih değişiklik talep/onay akışı.
// Kaynak: docs/FormDateChangeRequest_FE_Integration.md

export const formDateChangeRequestApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getFormDateChangeRequestList: builder.query({
            query: (params = {}) => ({
                url: 'v1/FormDateChangeRequest/GetList',
                method: 'POST',
                body: {
                    formType: params.formType ?? null,
                    formId: params.formId ?? null,
                    dateField: params.dateField ?? null,
                    status: params.status ?? null,
                    chassisNo: params.chassisNo ?? null,
                    startDate: params.startDate ?? null,
                    endDate: params.endDate ?? null,
                    pageNumber: params.pageNumber || 1,
                    pageSize: params.pageSize || 10
                }
            }),
            transformResponse: (response) => ({
                items: response?.data?.items ?? [],
                totalCount: response?.data?.totalCount ?? 0
            }),
            providesTags: ['FormDateChangeRequest']
        }),

        getFormDateChangeRequestById: builder.query({
            query: (id) => ({
                url: 'v1/FormDateChangeRequest/GetById',
                method: 'GET',
                params: { id }
            }),
            transformResponse: (response) => response?.data ?? null,
            providesTags: (result, error, id) => [{ type: 'FormDateChangeRequest', id }]
        }),

        addFormDateChangeRequest: builder.mutation({
            query: (body) => ({
                url: 'v1/FormDateChangeRequest/Add',
                method: 'POST',
                body
            }),
            invalidatesTags: (result, error, arg) => [
                'FormDateChangeRequest',
                // onaylanan/doğrudan uygulanan tarih ilgili formun cache'ini de bozar
                { type: 'VehicleAcceptanceForm', id: arg?.formId },
                { type: 'PreStockInspection', id: arg?.formId },
                { type: 'VehicleRegistrationForm', id: arg?.formId }
            ]
        }),

        approveFormDateChangeRequest: builder.mutation({
            query: (body) => ({
                url: 'v1/FormDateChangeRequest/Approvement',
                method: 'POST',
                body
            }),
            invalidatesTags: (result, error, arg) => ['FormDateChangeRequest', { type: 'FormDateChangeRequest', id: arg?.id }, 'VehicleAcceptanceForm', 'PreStockInspection', 'VehicleRegistrationForm']
        })
    }),
    overrideExisting: false
});

export const {
    useGetFormDateChangeRequestListQuery,
    useLazyGetFormDateChangeRequestListQuery,
    useGetFormDateChangeRequestByIdQuery,
    useLazyGetFormDateChangeRequestByIdQuery,
    useAddFormDateChangeRequestMutation,
    useApproveFormDateChangeRequestMutation
} = formDateChangeRequestApi;
